import { cx } from '@utils/cx'
import { getAvatarSrc } from '../../logic/getAvatarSrc'
import styles from './PlayerStatus.module.css'

/**
 * Presentational component for displaying a player's status.
 *
 * @param {Object} props
 * @param {Object} props.player - Player data (id, name, avatar, score)
 * @param {boolean} props.isActive - Whether this player is currently active
 * @param {number} [props.playerIndex] - Player index for color coding (0-3). Only used when multiplayerMobile is true.
 * @param {boolean} [props.multiplayerMobile] - Enables per-player colors for mobile multiplayer view
 * @param {string} props.avatarAlt - Alt text for avatar image (pre-translated)
 * @param {string} props.statSuffix - Visual suffix for stat (e.g., "pts")
 * @param {string} props.statAriaLabel - Full aria label for stat (pre-translated, e.g., "42 puntos")
 */
function PlayerStatus ({
  player,
  isActive = false,
  playerIndex = 0,
  multiplayerMobile = false,
  avatarAlt,
  statSuffix = 'pts',
  statAriaLabel
}) {
  // Only apply player-specific color in mobile multiplayer mode
  const playerColorStyle = (isActive && multiplayerMobile)
    ? { '--player-color': `var(--player-color-${playerIndex + 1})` }
    : undefined

  return (
    <div
      className={cx(styles.playerStatus, isActive && styles.isActive)}
      style={playerColorStyle}
    >
      <img
        src={getAvatarSrc(player.avatar)}
        alt={avatarAlt}
        className={styles.avatar}
      />
      <div className={styles.info}>
        <span className={styles.name}>{player.name}</span>
        <span
          className={styles.score}
          aria-label={statAriaLabel}
        >
          {player.score} {statSuffix}
        </span>
      </div>
    </div>
  )
}

export default PlayerStatus
